<template>
  <v-container>
    <v-row 
      justify = "center"
    >
      <v-col 
        cols  = "10" 
        md    = "10" 
        sm    = "10" 
        xl    = "10" 
        lg    = "10"
      >
      <v-card outlined>
        <!-- <v-card-title 
          title 
          primary 
          lass    = "headline grey lighten-2"  
          class   = "justify-center pa-0 body-2 blue lighten-1" 
          v-text  = "$ml.get('register_user')"
        ></v-card-title> -->
        <v-divider></v-divider>
        <v-card-text> 
        <v-form 
          name            = "form" 
          autocomplete    = "off"
        >
          <!-- @submit.prevent = "handleRegister" -->
          <v-row>
            <v-col> <!-- Info user -->
              <h4 
                class = "text-center"
              >
                {{ $ml.get('user_data') }}
              </h4>
              <v-divider></v-divider>
              <v-text-field 
                dense
                outlined
                hide-details
                :label        = "$ml.get('first_names')" 
                v-model       = "user.first_names" 
                prepend-inner-icon  = "mdi-account-outline" 
                type          = "text" 
                class         = "pa-0 mt-3"                
                @click        = "keyboard_is_active('name')"
              ></v-text-field>
              <v-text-field 
                dense
                outlined
                hide-details              
                :label        = "$ml.get('last_names')" 
                v-model       = "user.last_names" 
                prepend-inner-icon  = "mdi-clipboard-account" 
                type          = "text" 
                class         = "pa-0 mt-2"
                @click        = "keyboard_is_active('last_names')"
              ></v-text-field>
              <v-text-field 
                dense
                outlined                
                hide-details              
                :label        = "$ml.get('email')" 
                v-model       = "user.email"  
                prepend-inner-icon  = "mdi-email" 
                type          = "email"
                class         = "pa-0 mt-2"
                @click        = "keyboard_is_active('email')"
              ></v-text-field>
            </v-col>
            <v-col> <!-- Data user login -->
              <h4 
                class = "text-center"
              >
                {{ $ml.get('login_data') }}
              </h4>
              <v-divider ></v-divider>
                <v-select 
                  dense
                  outlined
                  hide-details
                  prepend-inner-icon  = "mdi-account-supervisor" 
                  class         = "pa-0  mt-3"
                  :label        = "$ml.get('user_role')" 
                  v-model       = "user.user_role" 
                  :items        = "availableRoleItems"
                  :item-text    = "'name'"
                  :item-value   = "'id'"
                ></v-select>
                <v-text-field 
                  dense                  
                  outlined
                  hide-details
                  type         = "text" 
                  class        = "pa-0 mt-2"
                  :label       = "$ml.get('username')" 
                  @click       = "keyboard_is_active('username')"
                  v-model      = "user.username"  
                  prepend-inner-icon  = "mdi-account" 
                  autocomplete        = "off"
                  name                = "username"                  
                ></v-text-field>                  
                <v-text-field 
                  dense                  
                  counter
                  outlined                  
                  :hint             = "user.password && user.password.length < 7 ? $ml.get('min_6_characters') : $ml.get('valid')"
                  type              = "password" 
                  class             = "pa-0 mt-2"
                  :label            = "$ml.get('password')" 
                  @click            = "keyboard_is_active('password')"
                  v-model           = "user.password" 
                  prepend-inner-icon  = "mdi-lock" 
                  :persistent-hint    = "true"                  
                  autocomplete        = "off"
                  name                = "password"                  
                ></v-text-field> 
                <v-text-field 
                  dense
                  counter
                  outlined                  
                  type              = "password" 
                  class             = "pa-0 mt-0"
                  :hint             = "check_data.match ? check_data.match : $ml.get('min_6_characters')"
                  :label            = "$ml.get('confirm_psw')" 
                  v-model           = "user.password1" 
                  prepend-inner-icon      = "mdi-lock" 
                  :persistent-hint  = "true"                  
                  @click            = "keyboard_is_active('password1')"
                ></v-text-field>
            </v-col>
          </v-row>         
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <p 
            v-if = "user.password1 && 
                    !check_data.validated && 
                    check_data.list_check.length > 0"
          >
            <span 
              class = "primary--text"
            > 
              {{ $ml.get('ms_complet') }} :
            </span>
            {{ String(check_data.list_check) }}          
          </p>
          <v-spacer></v-spacer>
          <v-btn 
            color     = "success" 
            type      = "submit" 
            v-text    = "$ml.get('register')" 
            v-if      = "!loading"
            :disabled = "!check_data.validated"
            @click    = "handleRegister"
          ></v-btn>
          <v-progress-circular
            indeterminate
            color = "primary"
            v-if  = "loading"
          ></v-progress-circular>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
  <template >
     <!--  <v-text-field 
        v-model="text_keyboard" 
        label="Search" 
        class="mx-4 pt-1" 
        append-icon="mdi-magnify" hide-details
        @input="text_keyboard"
        @click="keyboard_is_active()"
        outlined
        dense
      ></v-text-field> -->
        <!-- @keyup.enter="get_search(search)" -->
      <input 
        dark
        type    = "" 
        name    = ""
        @input  = "onInputChange"
        :value  = "input"
        class   = "input"
        v-show  = "false"
      >
        
      <v-bottom-sheet 
        dark
        inset 
        v-model  = "sheet" 
      >             
        <v-sheet 
          height = "300px" 
          class  = "pa-1"
        >
          <SimpleKeyboard 
            @onChange   = "onChange" 
            @onKeyPress = "onKeyPress" 
            :input      = "text_keyboard" 
            :theme      = "theme"
          />
        </v-sheet>
      </v-bottom-sheet>  
  </template>


  <v-snackbar
    top
    right
    :color    = "color"
    v-model   = "snackbar"
    :timeout  = "6000"
  >
    {{info}}
    
    <v-btn 
      small 
      color  = "error" 
      @click = "snackbar = false"
    >
      <v-icon 
        small
      >
        mdi-close
      </v-icon>
    </v-btn>
  </v-snackbar>
</v-container>
</template>

<script>
import User from '@/models/user';
import EventBus from '@/event-bus'
import SimpleKeyboard from "@/components/simple_Keyboard.vue";
export default {
  name: 'Register',
  components:{
    SimpleKeyboard
  }, // componenents
  data() {
    return {
      user       : new User('', '', '','','','',''),
      submitted  : false,
      successful : false,
      message    : '',
      dialog     : false,
      //select:'',
      select     : 0,
      items      : [
        { name : 'SuperAdmin', id : 1 }, // super_user
        { name : 'admin', id : 2 }, 
        { name : 'operator', id : 3}, 
        { name : 'owner', id : 4},
        { name : 'visitor', id : 5},
      ],
      info       : '',
      snackbar   : false,
      color      : '',
      loading    : false,
      mlt        : this.$ml.current,
      input      : '',
      theme      : 'hg-theme-default myTheme1', // myTheme1
      sheet      : false,
      text_keyboard : '',
      text_current  : '',
    };
  },

  created(){
    this.get_roles();
  }, // created

  watch:{
  /*  select(v){
      this.user.user_role = this.items_ml.indexOf(v) + 1;
      // console.log(this.user.user_role, 'user_role')
    }*/
    // mlt: function(v){
  
    //   console.log(v, 'ml',this.mlt,'mlt')
    // }
  },

  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
    /*items_ml(){
      let list  = this.items;
      let nlist = [];
      for (let i of list){
        // if (this.$ml.current=='english') {
            nlist.push(this.$ml.get(i));
        // }
        // else if (this.$ml.current=='spanish') {
        //     nlist.push(this.$ml.get(i));
        // }else if(this.$ml.current=='mongolian'){
        //     nlist.push(this.$ml.get(i));
        // }
      }
      return nlist;
    }, // items ml*/
    check_data: function(){
      let check      = this.user, 
          list_check = [], 
          validated  = true, 
          match      = '';
      
        if (!check.first_names) {
          validated = false;
          list_check.push(this.$ml.get('first_names'));
        }
        if (!check.last_names) {
          validated = false;
          list_check.push(this.$ml.get('last_names'));
        }
        if (!check.email) {
          validated = false;
          list_check.push(this.$ml.get('email'));
        }
        if (!check.user_role) {
          validated = false;
          list_check.push(this.$ml.get('user_role'));
        }
        if (!check.username) {
          validated = false;
          list_check.push(this.$ml.get('username'));
        }
        if (!check.password) {
          validated = false;
          list_check.push(this.$ml.get('password'));
        }
        if (!check.password1) {
          validated = false;
          list_check.push(this.$ml.get('confirm_psw'));
        }else{
          if (check.password !== check.password1) {
            validated = false;
            match     = this.$ml.get('no_match');
          }
        }

      return {validated, list_check, match};
    }, // check data

    currentUserRoleId(){
      return this.$store.state.auth.user?.user?.roleId || null;
    },

    currentUserRoleName(){
      return this.$store.state.auth.user?.user?.role?.name || '';
    },

    isCurrentUserSuperAdmin(){
      const currentRoleName = String(this.currentUserRoleName || '').toLowerCase();
      return currentRoleName == 'superadmin' || this.currentUserRoleId == 1;
    },

    availableRoleItems(){
      if (this.isCurrentUserSuperAdmin) {
        return this.items;
      }

      return this.items.filter(item => !this.isPrivilegedRole(item));
    },
  },
  mounted() {
    const timer = setTimeout(()=>{

      this.user.username = "Username";
      this.user.password = "password";
      const timer1 = setTimeout(()=>{
        this.user.username = "";
        this.user.password = "";
        clearTimeout(timer1);

      },200)
      clearTimeout(timer);
    },1000)
    // this.mlt=this.$ml.current;

    // if (this.loggedIn) {
    //   this.$router.push('/profile');
    // }
  },
  methods: {

    get_roles(){
      const api = this.$URL + "/api/v1/role"; 
      this.$axios.get(api).then(res => {
        if (res && res.data && res.data.rows && res.data.rows.length > 0) {
          this.items = res.data.rows;
         /* let idx = this.items.findIndex(x => (x && x.name == 'SuperAdmin'))
          if (idx >= 0) {
            this.items.splice(idx, 1);
          }*/

        }

        if (this.user.user_role && !this.availableRoleItems.some(role => role.id == this.user.user_role)) {
          this.user.user_role = '';
        }
        

      }).catch(err => {
        console.log("Error get roles register : ", err);
        this.$EventBus.$emit("notifications_modal", {
          type    : "error",
          message : err,
        })
      })
    }, // get roles 

    isPrivilegedRole(role){
      const roleName = String(role?.name || '').toLowerCase();
      return role && (role.id == 1 || role.id == 2 || roleName == 'superadmin' || roleName == 'admin');
    },

    handleRegister() {
      if (!this.$store.getters["auth/permission"](this.$route.name || "user", "can_add", "user")) {
        this.$EventBus.$emit("notifications_modal", {
          type    : "warning",
          message : this.$ml.get("no_have_permission_create") + " : " + this.$ml.get("user"), 
        })
        return false;
      }

      if (!this.availableRoleItems.some(role => role.id == this.user.user_role)) {
        this.$EventBus.$emit("notifications_modal", {
          type    : "warning",
          message : this.$ml.get("no_have_permission_create") + " : SuperAdmin / admin", 
        })
        return false;
      }

      this.message   = '';
      this.loading   = true;
      this.submitted = true;
    
          this.$store.dispatch('auth/register', this.user).then(
            res => {
              console.log(res, 'data')
            
              this.loading = false;
             
              if (res && res.message) {
                // console.log( res.response.data, 'data res login');
                let temp_er = res && res.response && res.response.data ? res.response.data : null;

                let msj = res && res.message ? res.message : this.$ml.get('registering_user');
                
                if (temp_er && temp_er.errors && temp_er.errors.length > 0) {
                  msj = temp_er.errors[0] && temp_er.errors[0].password ? this.$ml.get('invalid_password') : msj
                }
                if (temp_er && temp_er.msg &&  temp_er.msg.includes('Users_roleId_fkey')) {
                  msj = this.$ml.get('role_not_valid');
                }
                if (res.message == 'Network Error') {
                  msj = this.$ml.get('no_res_server');
                }
                EventBus.$emit('notifications_modal', {
                  type    : 'error',
                  message : msj
                })
              }else{                
                EventBus.$emit('notifications_modal', {
                  type : 'saved',
                })
              }
              EventBus.$emit('new_user', true);
            },
            error => {
              /*
                insert or update on table \"Users\" violates foreign key constraint \"Users_roleId_fkey\
              */
              let msj = error && error.message ? error.message : this.$ml.get('registering_user');
              if (error && error.msg &&  error.msg.includes('Users_roleId_fkey')) {
                msj = this.$ml.get('role_not_valid');
              }
              this.loading = false;

              EventBus.$emit('notifications_modal', {
                type : 'error',
                message: msj
              })
              console.log(error, 'error register')
              
            }
          );
        // }
      // });
    }, // handle register

     ml(){
      this.items_ml();
    },
    onChange(input) {
      this.input          = input;
      this.text_keyboard  = input;
      if (this.text_current == 'name') {
        this.user.first_names = input;
      }
      if (this.text_current == 'last_names') {
        this.user.last_names = input;
      }
      if (this.text_current == 'email') {
        this.user.email = input;
      }
      if (this.text_current == 'username') {
        this.user.username = input;
      }
      if (this.text_current == 'password') {
        this.user.password = input;
      }
      if (this.text_current == 'password1') {
        this.user.password1 = input;
      }
     

    },
    onKeyPress(button) {
      console.log("button", button);
      /*if (button=='{enter}') {
        this.get_search(this.search);
      }*/
    //   if (button=='{bksp}') {
    //     let str=this.input;
    //       if (str != null && str.length() > 0 && str.charAt(str.length() - 1) == 'x') {
    //     str = str.substring(0, str.length() - 1);
    // }
    //     this.input=text;
    //   }
    },
    onInputChange(input) {
      this.input = input.target.value;
      // this.search=input;
      if (this.text_current=='name') {
        this.user.first_names=input;
      }
       if (this.text_current=='last_names') {
        this.user.last_names=input;
      }
       if (this.text_current=='email') {
        this.user.email=input;
      }
       if (this.text_current=='username') {
        this.user.username=input;
      }
       if (this.text_current=='password') {
        this.user.password=input;
      }
       if (this.text_current=='password1') {
        this.user.password1=input;
      }
    },
    keyboard_is_active(keys){
      let key_board=false;
      if (localStorage.getItem('virtual_Key_board')) {
      key_board=JSON.parse(localStorage.getItem('virtual_Key_board'));
    }
    // console.log(key_board, 'before condition')
      if (key_board==true) {
        this.sheet=true;
        if (this.text_keyboard) {
          this.text_keyboard='';
        }
        this.text_current=keys;
        // console.log(key_board, this.sheet, 'while condition')
      }

      // console.log(key_board, this.sheet, 'activate key_board')
    },
  }, // methods
};
</script>
